import React from 'react';
import './Stats.css';

const statsData = [
  {
    value: '100',
    unit: '+',
    label: 'IT Professionals',
  },
  {
    value: '200',
    unit: '+',
    label: 'Non-IT Experts',
  },
  {
    value: '50',
    unit: '+',
    label: 'Corporate Clients Served',
  },
  {
    value: '30',
    unit: '+',
    label: 'Global Locations',
  },
];

const Stats = () => {
  return (
    <div className="stats-container">
      {statsData.map((stat, index) => (
        <div
          key={index}
          className={`stat-block ${index !== statsData.length - 1 ? 'border-right' : ''}`}
        >
          <div className="stat-value">
            {stat.value}
            <span className="stat-unit">{stat.unit}</span>
          </div>
          <div className="stat-label">{stat.label}</div>
        </div>
      ))}
    </div>
  );
};

export default Stats;
